import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';
const path = '/api/private/users';

/**
 * リスト取得
 * @param param {object}
 */
const list = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/list`,
    params: param,
  });
};

/**
 * 1レコード取得
 * @param {number} id ユーザーID
 */
const show = id => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/users/${id}`,
  });
};

/**
 * 登録
 * @param param {object}
 */
const create = param => {
  return requestWithToken({
    method: 'POST',
    url: path,
    data: createFormData(param),
    validateStatus(status) {
      // Reject only if the status code 422
      return status === 422 || status === 200;
    },
  });
};

/**
 * 更新
 */
const update = (id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/update_full/${id}`,
    data: createFormData(param),
  });
};

/**
 * データパラメータ生成
 * @param param {object}
 * @return fd {object}
 */
function createFormData(param) {
  var fd = new FormData();
  _.each(param, (value, index) => {
    if (value && value.type == 'file') {
      fd.append('user_image', value.files[0]);
    } else {
      if (Object.prototype.toString.call(value) === '[object Object]') {
        // eslint-disable-next-line no-unused-vars
        let obj = {};
        _.each(value, (val, col) => {
          fd.append(`${index}[${col}]`, val == undefined ? '' : val);
        });
      } else {
        fd.append(index, value == undefined ? '' : value);
      }
    }
  });

  return fd;
}

/**
 *
 * 代行登録許可ユーザー情報取得API
 * @param {*} params
 */
const getAgencyRegistableCompanies = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`/agency_registable_companies`),
      params,
    },
    true,
    false
  );
};

/**
 * 代行登録会社候補取得API
 * @param {*} param
 */
const agencyCompanyCandidates = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/agency_company_candidates`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const agencyUserCandidates = param => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/agency_user_candidates`,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

const createIntegrate = data => {
  return requestWithToken({
    method: 'POST',
    url: `${path}/create_integrate`,
    data,
  });
};

const updateIntegrate = (id, data) => {
  return requestWithToken({
    method: 'PATCH',
    url: `${path}/update_full_integrate/${id}`,
    data,
  });
};

export const UserService = {
  agencyUserCandidates,
  agencyCompanyCandidates,
  create,
  update,
  list,
  show,
  getAgencyRegistableCompanies,
  createIntegrate,
  updateIntegrate,
};
export default UserService;



// WEBPACK FOOTER //
// ./src/services/Users.js